// Iconoir icons for the verb vocabulary (api/vocabulary.yaml). Explicit imports keep the bundle small;
// icons.test.ts fails when a vocabulary icon is missing here.
import {
  Archive,
  ArrowUpCircle,
  BookmarkBook,
  Box,
  Check,
  CheckCircle,
  ClosedCaptionsTag,
  Combine,
  Compress,
  DoubleCheck,
  Download,
  EditPencil,
  Eye,
  Filter,
  Forward,
  GitFork,
  Hourglass,
  Import,
  KeyMinus,
  List,
  Lock,
  Notes,
  OpenNewWindow,
  Page,
  Pause,
  Pin,
  PinSolid,
  Play,
  Plus,
  Prohibition,
  RefreshDouble,
  Restart,
  ScanBarcode,
  Search,
  Settings,
  ShieldCheck,
  ShareIos,
  StatUp,
  TextSquare,
  Timer,
  Undo,
  UndoAction,
  Upload,
  Xmark,
  XmarkCircle,
} from "iconoir-react";
import type { IconoirIcon } from "@/shell/registry/panels";

export const verbIconComponents: Readonly<Record<string, IconoirIcon>> = {
  Archive,
  ArrowUpCircle,
  BookmarkBook,
  Box,
  Check,
  CheckCircle,
  ClosedCaptionsTag,
  Combine,
  Compress,
  DoubleCheck,
  Download,
  EditPencil,
  Eye,
  Filter,
  Forward,
  GitFork,
  Hourglass,
  Import,
  KeyMinus,
  List,
  Lock,
  Notes,
  OpenNewWindow,
  Page,
  Pause,
  Pin,
  PinSolid,
  Play,
  Plus,
  Prohibition,
  RefreshDouble,
  Restart,
  ScanBarcode,
  Search,
  Settings,
  ShieldCheck,
  ShareIos,
  StatUp,
  TextSquare,
  Timer,
  Undo,
  UndoAction,
  Upload,
  Xmark,
  XmarkCircle,
};
